export default "__VITE_ASSET__dzvhT9DI__"